import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-session-expiry-dialog',
  template: `
    <h2 mat-dialog-title>Sitzung läuft ab</h2>
    <mat-dialog-content>
      <p>Ihre Sitzung ist abgelaufen. Bitte erneuern Sie Ihre Sitzung, um fortzufahren.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="onRenew()">Session erneuern</button>
    </mat-dialog-actions>
  `
})
export class SessionExpiryDialogComponent {
  constructor(private dialogRef: MatDialogRef<SessionExpiryDialogComponent>) {
    this.dialogRef.disableClose = true;
  }

  onRenew(): void {
    this.dialogRef.close('renew');
  }
}
